export const PAGE_HOME = 'pg_home';